(() => {
  if (window.APC_CUSTOM_WEDDING_QUANTITY_FILTER) {
    window.APC_CUSTOM_WEDDING_QUANTITY_FILTER.initialiseWithin(document);
    return;
  }

  const initializedPickers = new WeakSet();
  const normalise = (value) => value.trim().toLowerCase();

  function initialisePicker(picker) {
    if (initializedPickers.has(picker)) return;

    const root = picker.closest('product-info[data-custom-wedding-product]');
    const variantsJson = picker.querySelector('[data-product-variants]');

    if (!root || !variantsJson) return;

    let variants;

    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (error) {
      console.error(
        'Unable to read custom-wedding product variants.',
        error
      );
      return;
    }

    const optionControls = Array.from(
      picker.querySelectorAll(
        'fieldset, .product-form__input--dropdown'
      )
    );

    const optionPositions = new Map();

    optionControls.forEach((control, index) => {
      const heading = control.querySelector(
        'legend, label.form__label'
      );

      if (heading) {
        optionPositions.set(
          normalise(heading.textContent),
          index
        );
      }
    });

    const bagSizePosition = optionPositions.get('bag size');
    const flavorPosition = optionPositions.get('flavor');
    const quantityPackPosition = optionPositions.get('quantity pack');

    if (
      bagSizePosition === undefined ||
      quantityPackPosition === undefined
    ) {
      return;
    }

    let filtering = false;

    function getSelectedValue(position) {
      const control = optionControls[position];

      if (!control) return null;

      const checked = control.querySelector(
        'input[type="radio"]:checked'
      );

      if (checked) return checked.value;

      const select = control.querySelector('select');

      return select ? select.value : null;
    }

    function dispatchVariantChange(control) {
      control.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }

    function filterVariantOptions() {
      if (filtering) return;

      filtering = true;

      try {
        const selectedBagSize =
          getSelectedValue(bagSizePosition);

        if (!selectedBagSize) return;

        /*
         * FILTER FLAVORS
         *
         * Show only flavors that have an available
         * Shopify variant for the selected bag size.
         */
        if (flavorPosition !== undefined) {
          const validFlavors = new Set(
            variants
              .filter((variant) => {
                return (
                  variant.available &&
                  variant.options[bagSizePosition] ===
                    selectedBagSize
                );
              })
              .map(
                (variant) =>
                  variant.options[flavorPosition]
              )
          );

          const flavorControl =
            optionControls[flavorPosition];

          if (flavorControl) {
            const flavorRadios = Array.from(
              flavorControl.querySelectorAll(
                'input[type="radio"]'
              )
            );

            if (flavorRadios.length) {
              flavorRadios.forEach((radio) => {
                const label =
                  flavorControl.querySelector(
                    `label[for="${CSS.escape(
                      radio.id
                    )}"]`
                  );

                const isValid = validFlavors.has(
                  radio.value
                );

                if (label) {
                  label.hidden = !isValid;
                }

                radio.disabled = !isValid;

                if (!isValid && radio.checked) {
                  radio.checked = false;
                }
              });

              if (
                !flavorControl.querySelector(
                  'input[type="radio"]:checked'
                )
              ) {
                const firstValidFlavor =
                  flavorRadios.find((radio) =>
                    validFlavors.has(radio.value)
                  );

                if (firstValidFlavor) {
                  firstValidFlavor.checked = true;

                  dispatchVariantChange(
                    firstValidFlavor
                  );
                }
              }
            } else {
              const flavorSelect =
                flavorControl.querySelector('select');

              if (flavorSelect) {
                Array.from(
                  flavorSelect.options
                ).forEach((option) => {
                  const isValid =
                    validFlavors.has(option.value);

                  option.hidden = !isValid;
                  option.disabled = !isValid;
                });

                if (
                  !validFlavors.has(
                    flavorSelect.value
                  )
                ) {
                  const firstValidFlavor =
                    Array.from(
                      flavorSelect.options
                    ).find((option) =>
                      validFlavors.has(
                        option.value
                      )
                    );

                  if (firstValidFlavor) {
                    flavorSelect.value =
                      firstValidFlavor.value;

                    dispatchVariantChange(
                      flavorSelect
                    );
                  }
                }
              }
            }
          }
        }

        /*
         * FILTER QUANTITY PACKS
         *
         * After the flavor has been validated,
         * show only quantity packs that exist
         * for the selected Bag Size + Flavor.
         */
        const selectedFlavor =
          flavorPosition === undefined
            ? null
            : getSelectedValue(flavorPosition);

        const validValues = new Set(
          variants
            .filter((variant) => {
              return (
                variant.available &&
                variant.options[
                  bagSizePosition
                ] === selectedBagSize &&
                (
                  !selectedFlavor ||
                  variant.options[
                    flavorPosition
                  ] === selectedFlavor
                )
              );
            })
            .map(
              (variant) =>
                variant.options[
                  quantityPackPosition
                ]
            )
        );

        const quantityControl =
          optionControls[quantityPackPosition];

        if (!quantityControl) return;

        const radios = Array.from(
          quantityControl.querySelectorAll(
            'input[type="radio"]'
          )
        );

        if (radios.length) {
          radios.forEach((radio) => {
            const label =
              quantityControl.querySelector(
                `label[for="${CSS.escape(
                  radio.id
                )}"]`
              );

            const isValid =
              validValues.has(radio.value);

            if (label) {
              label.hidden = !isValid;
            }

            radio.disabled = !isValid;

            if (!isValid && radio.checked) {
              radio.checked = false;
            }
          });

          if (
            !quantityControl.querySelector(
              'input[type="radio"]:checked'
            )
          ) {
            const firstValid = radios.find(
              (radio) =>
                validValues.has(radio.value)
            );

            if (firstValid) {
              firstValid.checked = true;

              dispatchVariantChange(firstValid);
            }
          }

          return;
        }

        const select =
          quantityControl.querySelector('select');

        if (!select) return;

        Array.from(select.options).forEach(
          (option) => {
            const isValid =
              validValues.has(option.value);

            option.hidden = !isValid;
            option.disabled = !isValid;
          }
        );

        if (!validValues.has(select.value)) {
          const firstValid =
            Array.from(select.options).find(
              (option) =>
                validValues.has(option.value)
            );

          if (firstValid) {
            select.value = firstValid.value;

            dispatchVariantChange(select);
          }
        }
      } finally {
        filtering = false;
      }
    }

    picker.addEventListener('change', () => {
      window.setTimeout(
        filterVariantOptions,
        0
      );
    });

    filterVariantOptions();

    initializedPickers.add(picker);
  }

  function initialiseWithin(root) {
    if (
      !(
        root instanceof Element ||
        root instanceof Document
      )
    ) {
      return;
    }

    root
      .querySelectorAll(
        'product-info[data-custom-wedding-product] variant-selects'
      )
      .forEach(initialisePicker);
  }

  function start() {
    initialiseWithin(document);

    const observer = new MutationObserver(
      (mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach(
            (node) => {
              if (!(node instanceof Element)) {
                return;
              }

              if (
                node.matches('variant-selects')
              ) {
                initialisePicker(node);
              }

              initialiseWithin(node);
            }
          );
        });
      }
    );

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  window.APC_CUSTOM_WEDDING_QUANTITY_FILTER = {
    initialiseWithin
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();